import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data: data
  })
}

export function getInfo(data) {
  return request({
    url: '/auth/validatetoken',
    method: 'post',
    data: data
  })
}
//POST /auth/tokenLogin token登录
export function tokenLogin(data) {
  return request({
    url: '/auth/validatetoken',
    method: 'post',
    data: data
  })
}
//POST /auth/refreshToken 刷新token
export function refToken(data) {
  return request({
    url: '/auth/refreshtoken',
    method: 'post',
    data: data
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}







// WEBPACK FOOTER //
// ./src/api/login.js